import React, { useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, Loader2 } from "lucide-react";
import { apiPost } from "../lib/api";
import MotionButton from "./motion/MotionButton";

export default function QuestionFeedback({ question, result }) {
  const [aiLoading, setAiLoading] = useState(false);
  const [aiText, setAiText] = useState("");

  const askAI = async () => {
    if (aiLoading) return;
    setAiLoading(true);
    try {
      const r = await apiPost("/ai/explain", { question_id: question.question_id });
      setAiText(r.explanation || "Nessuna spiegazione disponibile.");
    } finally {
      setAiLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mt-6"
    >
      <div
        className={`text-sm font-semibold mb-3 ${result.is_correct ? "text-brand-green" : "text-brand-red"}`}
        data-testid="answer-result-text"
      >
        {result.is_correct ? "✓ Risposta corretta" : "✗ Risposta sbagliata"}
      </div>

      <div className="border border-brand-border bg-brand-background rounded-xl p-4">
        <div className="eyebrow mb-2">// Spiegazione</div>
        <p className="text-sm text-brand-primary/85 leading-relaxed">{result.explanation}</p>
      </div>

      <div className="mt-4 border border-brand-green/30 bg-brand-green/[0.06] rounded-xl p-4">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2 text-brand-green">
            <Sparkles className="h-4 w-4" />
            <span className="eyebrow text-brand-green text-[10px]">// Tutor AI · GPT-5.2</span>
          </div>
          {!aiText && (
            <MotionButton
              data-testid="ask-ai-btn"
              variant="secondary"
              size="sm"
              onClick={askAI}
              disabled={aiLoading}
            >
              {aiLoading ? <><Loader2 className="h-3 w-3 animate-spin" /> Analisi...</> : "Chiedi al tutor"}
            </MotionButton>
          )}
        </div>
        {aiText && (
          <p data-testid="ai-explanation-text" className="text-sm text-brand-primary/85 leading-relaxed whitespace-pre-wrap mt-3">
            {aiText}
          </p>
        )}
      </div>
    </motion.div>
  );
}
